import { limit, orderBy, query } from 'firebase/firestore'
import { ArrayService } from './serviceLive'
import type { UsageDetail } from '~/models/MedicationAgreement/UsageDetail'

export class UsageDatailService extends ArrayService<UsageDetail> {
  private _collection

  constructor() {
    super('MedicationAgreement', { collectionGroupName: 'UsageDetails' })
    const { collection } = useFirebase()
    this._collection = collection
  }

  public listenForUsageDetailsByMedicationAgreementIds(
    medicationAgreementIds: string[],
  ): void {
    const listenQueries = medicationAgreementIds.map(medicationAgreementId =>
      this.buildQuery(medicationAgreementId),
    )

    this.listenGroup(listenQueries)
  }

  private buildQuery(medicationAgreementId: string) {
    return query(
      this._collection(
        `MedicationAgreement/${medicationAgreementId}/UsageDetails`,
      ),
      orderBy('Created', 'desc'),
      limit(1),
    )
  }
}
